import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_VoKasutajaInfo = _resolveComponent("VoKasutajaInfo")!

  return (_ctx.vatekSisselogimine)
    ? (_openBlock(), _createBlock(_component_VoKasutajaInfo, {
        key: 0,
        loading: _ctx.loading,
        kasutajaTaisNimi: _ctx.taisNimi,
        kasutajaInitsiaalid: _ctx.initsiaalid
      }, {
        logOutNupp: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "text-subtitle-1 px-2 me-8",
                    onClick: _ctx.backToVatek,
                    variant: "tonal"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Mine VaTeK avalehele ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    class: "text-subtitle-1 px-2 me-n2",
                    onClick: _ctx.logoutVatek,
                    variant: "text",
                    "prepend-icon": "mdi-logout"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Logi välja KRHP-st ja VaTeK-ist ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "kasutajaTaisNimi", "kasutajaInitsiaalid"]))
    : (_openBlock(), _createBlock(_component_VoKasutajaInfo, {
        key: 1,
        loading: _ctx.loading,
        kasutajaTaisNimi: _ctx.taisNimi,
        kasutajaInitsiaalid: _ctx.initsiaalid,
        onLogiValja: _ctx.logiValja,
        class: "ma-0"
      }, null, 8, ["loading", "kasutajaTaisNimi", "kasutajaInitsiaalid", "onLogiValja"]))
}